import "./index.css";
import LogRocket from "logrocket";
import React from "react";
import ReactDOM from "react-dom/client";
import TagManager from "react-gtm-module";
import Swal from "sweetalert2";
import App from "./App";
import ErrorBoundary from "./components/ErrorBoundary/errorBoundary.component";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import UserProvider from "./services/AppContext/appProvider";
import { SocketProvider } from "./services/SocketContext";
// import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { checkExclude, systemErrorAlertText } from "./utilities/utils";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

async function initializeLogRocket(environment: string) {
  const logRocketID = process.env.REACT_APP_LOG_ROCKET_ID;

  if (!logRocketID) {
    console.error("REACT_APP_LOG_ROCKET_ID is not set");
    Swal.fire({
      title: "Error",
      text: "REACT_APP_LOG_ROCKET_ID is not set" + systemErrorAlertText(),
      icon: "error"
    });
    return;
  }

  if (environment === "production") {
    console.log = function () {};
    console.warn = function () {};
    console.error = function () {};
  }

  LogRocket.init(logRocketID);
}

function initializeGoogleTagManager(environment: string) {
  const googleTagManagerID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID;

  if (!googleTagManagerID) {
    console.error("REACT_APP_GOOGLE_TAG_MANAGER_ID is not set");
    Swal.fire({
      title: "Error",
      text:
        "REACT_APP_GOOGLE_TAG_MANAGER_ID is not set" + systemErrorAlertText(),
      icon: "error"
    });
    return;
  }

  const tagManagerArgs: TagManager.TagManagerArgs = {
    gtmId: googleTagManagerID
  };

  TagManager.initialize(tagManagerArgs);
}

async function initializeTracking() {
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (!environment) {
    console.error("REACT_APP_ENVIRONMENT is not set");
    Swal.fire({
      title: "Error",
      html: "REACT_APP_ENVIRONMENT is not set" + systemErrorAlertText(),
      icon: "error"
    });
    return;
  }
  const exclude = await checkExclude();

  if (exclude || (environment !== "production" && environment !== "staging")) {
    return;
  }

  initializeGoogleTagManager(environment);
  initializeLogRocket(environment);
}

initializeTracking();

root.render(
  <ErrorBoundary>
    <SocketProvider>
      <UserProvider>
        <React.StrictMode>
          <App />
        </React.StrictMode>
      </UserProvider>
    </SocketProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// // Service Worker Registration
// serviceWorkerRegistration.register();
